<sw-page class="dvsn-form-builder dvsn-form-builder-submission-list">
    <template #search-bar>
        <sw-search-bar
            :initialSearchType="$t('dvsn-form-builder-submission.list.search.type')"
            :placeholder="$t('dvsn-form-builder-submission.list.search.placeholder')"
            :initialSearch="term"
            @search="onSearch"
        />
    </template>

    <template #side-content>
        <dvsn-form-builder-side-menu
            active="submission"
            :isLoading="isLoading"
        ></dvsn-form-builder-side-menu>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="submissions"
            :items="submissions"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :showActions="true"
            :showSelection="false"
            :showSettings="false"
            detailRoute="dvsn.form.builder.submission.detail"
            @page-change="onPageChange"
        >
            <template #column-formId="{ item }">
                <span v-if="item.form">
                    <router-link
                        :title="$t('dvsn-form-builder-submission.list.column-form')"
                        :to="{ name: 'dvsn.form.builder.submission.detail', params: { id: item.id } }"
                    >
                        {{ item.form.name }}
                    </router-link>
                </span>

                <span v-else>
                    <span style="color: #ccc">---</span>
                </span>
            </template>

            <template #column-customerId="{ item }">
                <span v-if="item.customer">
                    {{ item.customer.firstName }} {{ item.customer.lastName }}
                </span>

                <span v-else>
                    <span style="color: #ccc">---</span>
                </span>
            </template>

            <template #column-salesChannelId="{ item }">
                <span v-if="item.salesChannel">
                    {{ item.salesChannel.name }}
                </span>

                <span v-else>
                    <span style="color: #ccc">---</span>
                </span>
            </template>

            <template #column-createdAt="{ item }">
                {{ dateFilter(item.createdAt, {hour: '2-digit', minute: '2-digit', second: '2-digit'}) }} Uhr
            </template>

            <template #detail-action="{ item }">
                <sw-context-menu-item
                    class="sw-entity-listing__context-menu-edit-action"
                    :router-link="{ name: 'dvsn.form.builder.submission.detail', params: { id: item.id } }"
                >
                    {{ $t('dvsn-form-builder-submission.list.actions.view') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <mt-loader v-if="isLoading"/>
    </template>

    <template #sidebar>
        <sw-sidebar>
            <sw-sidebar-item
                icon="regular-undo"
                :title="$t('dvsn-form-builder-submission.list.sidebar.refresh')"
                @click="onRefresh"
            />
        </sw-sidebar>
    </template>
</sw-page>